var React = require('react');

function GrayArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#807857","key":0}),React.createElement("path",{"d":"M18.3667 24L16.9333 22.6029L22.5333 17.0146H5V15.0187H22.5333L16.9 9.39709L18.3333 8L26.3667 16.0166L18.3667 24Z","fill":"white","key":1})]);
}

GrayArrow.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = GrayArrow;

GrayArrow.default = GrayArrow;
